require('../../modules/es.object.assign');
var path = require('../../internals/path');

module.exports = path.Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/object/assign.js
// module id = 1220
// module chunks = 1